<template>
  <div class="mdm_group_page">
    <h3 class="title-page">{{ $t("unit") }}</h3>
    <div>
      <div class="admin_container">
        <div class="mdm_main">
          <div>
            <v-btn
              dark
              color="primary"
              class="ml-auto mb-5"
              style="display: block"
              @click="dialog = true"
            >
              {{ $t("create") }}
            </v-btn>
          </div>
          <table-with-filter
            fixed-header
            :headers="headers"
            :items="items"
            :page="configuration.page"
          >
            <template #filter.nameEn>
              <div class="pa-1">
                <custom-input-text
                  class="user_input no-margin"
                  v-model="configuration.name"
                  @input="filterUnitType"
                  clearable
                />
              </div>
            </template>
            <template #item.action="{ item }">
              <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="edit(item)"
                  >
                    <vue-icon icon="newPencilIcon" />
                  </v-btn>
                </template>
                <span>{{ $t("edit") }}</span>
              </v-tooltip>
              <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="deleteItem(item)"
                  >
                    <vue-icon icon="newTrashIcon" />
                  </v-btn>
                </template>
                <span>{{ $t("delete") }}</span>
              </v-tooltip>
            </template>
          </table-with-filter>
          <vue-pagination
            @update:limit="
              (limit) => {
                configuration.limit = limit;
                configuration.page = 1;
                changePage();
              }
            "
            v-model="configuration.page"
            :length="lastPage"
            @input="changePage"
            max-page
            :limit="configuration.limit"
          />
        </div>
      </div>
    </div>
    <v-dialog
      v-model="dialog"
      @click:outside="dialog = false"
      persistent
      max-width="528"
      class="user_modal_dialog"
    >
      <v-card>
        <validation-observer v-slot="{ handleSubmit }" ref="form">
          <v-form @submit.prevent="handleSubmit(saveAttribute)">
            <v-card-title class="">
              <span class="headline title_modal_user">{{ formTitle }}</span>
              <v-icon @click="dialog = false" class="info_modal_close"
                >mdi-close</v-icon
              >
            </v-card-title>
            <v-card-text class="main_modal my-n2">
              <div class="py-2">
                <custom-input-text
                  :label="$t('name') + ' En' + '*'"
                  rules="required"
                  v-model="formData.nameEn"
                  class="user_input no-margin"
                ></custom-input-text>
              </div>
              <div class="py-2">
                <custom-input-text
                  rules="required"
                  class="user_input no-margin"
                  v-model="formData.nameRu"
                  :label="$t('name') + ' Ru' + '*'"
                ></custom-input-text>
              </div>
              <div class="py-2">
                <custom-input-text
                  rules="required"
                  class="user_input no-margin"
                  v-model="formData.nameUz"
                  :label="$t('name') + ' Uz' + '*'"
                ></custom-input-text>
              </div>
              <div class="py-2">
                <custom-input-text
                  rules="required"
                  class="user_input no-margin"
                  v-model="formData.nameCyrl"
                  :label="$t('name') + ' Cyrl' + '*'"
                ></custom-input-text>
              </div>

              <div class="py-2">
                <v-switch
                  hide-details
                  class="mt-0"
                  :label="$t('productPackageType.COUNTABLE')"
                  :items="PACKAGE_TYPES"
                  item-text="text"
                  item-value="value"
                  v-model="formData.countable"
                ></v-switch>
              </div>
            </v-card-text>
            <v-card-actions class="footer_modal_user">
              <div class="row">
                <div
                  class="d-flex flex-wrap justify-space-around button_modal_add mr-3 mt-3"
                >
                  <v-btn color="primary" dark type="submit"
                    >{{ $t("save") }}
                  </v-btn>
                </div>
              </div>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card>
    </v-dialog>
    <warning-dialog
      @apply="deleteItemHandler"
      v-model="confirmDialog"
    ></warning-dialog>
  </div>
</template>

<script>
import WarningDialog from "@/components/ui/prompt/warning-dialog";
import {
  debounce,
  getValueByKey,
  makerPagination,
} from "@/utils/pureFunctions";
import { PACKAGE_TYPES } from "@/utils/constants";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";

export default {
  name: "reference-unit-type",
  data() {
    return {
      confirmDialog: false,
      dialog: false,
      items: [],
      formData: {
        nameEn: null,
        nameRu: null,
        nameUz: null,
        nameCyrl: null,
        countable: false,
      },
      configuration: {
        limit: "20",
        page: 1,
        name: null,
      },
      lastPage: 0,
    };
  },
  computed: {
    isEditingItem() {
      return !this.formData.id;
    },
    formTitle() {
      return this.isEditingItem ? this.$t("create") : this.$t("editGroup");
    },
    headers() {
      return [
        {
          text: `${this.$t("designation")} EN`,
          value: "nameEn",
        },
        {
          text: `${this.$t("designation")} RU`,
          value: "nameRu",
        },
        {
          text: `${this.$t("designation")} UZ`,
          value: "nameUz",
        },
        {
          text: `${this.$t("designation")} Cyrl`,
          value: "nameCyrl",
        },
        {
          text: this.$t("action"),
          value: "action",
        },
      ];
    },
    PACKAGE_TYPES() {
      return PACKAGE_TYPES.map((item) => {
        return {
          text: this.$t(`productPackageType.${item}`),
          value: item,
        };
      });
    },
  },
  components: {
    VuePagination,
    TableWithFilter,
    WarningDialog,
  },
  watch: {
    confirmDialog(val) {
      if (!val) this.clearForm();
    },
    dialog(val) {
      if (!val) this.clearForm();
    },
  },
  methods: {
    filterUnitType: debounce(async function () {
      await this.$router.replace({ query: { ...this.configuration } });
      this.showLoading();
      await this.getItems();
      this.clearLoading();
    }, 300),
    clearForm() {
      const { form } = this.$refs;
      this.formData = {
        nameEn: null,
        nameRu: null,
        nameUz: null,
      };
      if (form) form.reset();
    },
    async deleteItemHandler() {
      try {
        await this.$http.delete(
          "unit-type/delete?id=" + this.attributeFormData.id
        );
        await this.getItems();
        this.setSuccess({
          title: this.$t("successfullyDeleted"),
        });
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    deleteItem(item) {
      this.confirmDialog = true;
      this.attributeFormData = { ...item };
    },
    edit(item) {
      this.dialog = true;
      this.formData = {
        id: item.id,
        nameEn: item.nameEn,
        nameRu: item.nameRu,
        nameUz: item.nameUz,
        nameCyrl: item.nameCyrl,
      };
    },
    async saveAttribute() {
      this.showLoading();
      this.formData.id = this.formData.id ? this.formData.id : null;
      try {
        await this.$http.post("unit-type/save", this.formData);
        await this.getItems();
        this.dialog = false;
        this.clearForm();
        this.setSuccess({
          title: this.$t("successfullySaved"),
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async getItems() {
      const { page, limit, name } = this.configuration;
      let params = { page: page - 1, limit, name };
      this.showLoading();
      try {
        const {
          data: { data, total },
        } = await this.$http.get("unit-type/list", {
          params,
        });
        this.items = data;
        this.lastPage = makerPagination({ limit, total }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async changePage() {
      await this.$router.replace({ query: { ...this.configuration } });
      this.showLoading();
      await this.getItems();
      this.clearLoading();
    },
  },
  async created() {
    const options = getValueByKey(this.configuration, this.$route.query);
    if (options.page && !isNaN(options.page)) options.page = +options.page;
    this.configuration = options;

    this.showLoading();
    await this.getItems();
    this.clearLoading();
  },
};
</script>

<style scoped></style>
